import { Theme } from "@mui/material";

export const modalBoxStyles = (theme: Theme) => ({
  display: "flex",
  flexDirection: "column",
  gap: "16px",
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  borderRadius: "16px",
  padding: "22px",
  boxShadow: 24,
  backgroundColor: theme.palette.modalColors.bgColor,
  width: { xs: "90%", sm: "70%", md: "60%" },
  maxHeight: { xs: "80dvh", sm: "80dvh", md: "80dvh" },
  overflowY: "auto",
});

export const closeModalBoxStyles = (theme: Theme) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "16px",
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  borderRadius: "16px",
  padding: "2rem 5rem",
  boxShadow: 24,
  backgroundColor: theme.palette.modalColors.bgColor,
  maxHeight: { xs: "80dvh", sm: "80dvh", md: "80dvh" },
  overflowY: "auto",
});

export const buttonsContainerStyles = {
  marginY: "1rem",
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-end",
  gap: "1rem",
};

export const previewButtonStyles = {
  height: "40px",
  borderRadius: "20px",
  paddingX: "2rem",
  textTransform: "none",
  borderColor: "rgb(25, 118, 210)",
  color: "rgb(25, 118, 210)",
  boxShadow: "none",
  "&:hover": {
    boxShadow: "none",
    background: "rgba(25, 118, 210, 0.1)",
  },
};

export const sendButtonStyles = {
  height: "40px",
  borderRadius: "20px",
  paddingX: "2rem",
  textTransform: "none",
  background: "rgb(25, 118, 210)",
  boxShadow: "none",
  "&:hover": {
    boxShadow: "none",
    background: "rgb(17, 100, 183)",
  },
};

export const closeButtonStyles = {
  marginY: "1rem",
  height: "40px",
  borderRadius: "20px",
  paddingX: "2rem",
  textTransform: "none",
  background: "rgb(25, 118, 210)",
  boxShadow: "none",
  "&:hover": {
    boxShadow: "none",
    background: "rgb(17, 100, 183)",
  },
};

export const textFieldStyles = (theme: Theme) => ({
  "& .MuiFormLabel-root": {
    color: theme.palette.panelInfo.calendar.lableColor,
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: theme.palette.panelInfo.selector.borderColor,
  },
  "&:hover .MuiFormLabel-root": {
    color: theme.palette.panelInfo.calendar.lableColor,
  },
  "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: theme.palette.panelInfo.selector.borderColor,
  },
  "& .MuiFormLabel-root.Mui-focused": {
    color: "#06B6D4",
  },
  "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "#06B6D4",
  },
  marginY: "0.5rem",
});

export const popperStyles = (theme: Theme) => ({
  "& .MuiPaper-root": {
    "--Paper-overlay": "none !important",
    backgroundColor: theme.palette.panelInfo.calendar.bg,
    borderRadius: 2,
    boxShadow: "0 4px 16px rgba(0, 0, 0, 0.1)",
  },
});

export const layoutStyles = {
  "& .MuiPickersCalendarHeader-root": {
    borderRadius: 1,
    mb: 1,
  },
};

export const dayStyles = (theme: Theme) => ({
  borderRadius: "10px",
  "&:hover": {
    backgroundColor: theme.palette.panelInfo.calendar.days.bgHover,
  },
  "&.Mui-selected": {
    backgroundColor: "#06B6D4 !important",
    color: "#fff !important",
  },
  "&.MuiPickersDay-today": {
    color: "#06B6D4",
    border: "none",
    backgroundColor: theme.palette.panelInfo.calendar.days.todayBG,
  },
});

export const yearButtonStyles = (theme: any) => ({
  "&.Mui-selected": {
    backgroundColor: "#06B6D4 !important",
    color: "#fff !important",
  },
  "&:hover": {
    backgroundColor: theme.palette.panelInfo.calendar.days.bgHover,
  },
});
